function isMobile() {
  return window.innerWidth < 768;
}

// Helper to get current mode
function getCurrentMode() {
  return document.body.getAttribute('data-card-mode') || 'produit';
}

function updateAllSwipers() {
  const mode = getCurrentMode();
  document.querySelectorAll('.card-wrapper').forEach(card => {
    if (card.swiperInstance) {
      const swiper = card.swiperInstance;
      // Fixed logic: produit mode should show index 0 (first image)
      if (mode === 'modele') {
        swiper.slideToLoop(1, 0); // Show second image (model)
      } else if (mode === 'produit') {
        swiper.slideToLoop(0, 0); // Show first image (product)
      }
    }
  });
}

document.addEventListener('DOMContentLoaded', function () {
  // Set initial mode if not set
  if (!document.body.hasAttribute('data-card-mode')) {
    document.body.setAttribute('data-card-mode', 'produit');
  }
  
  initializeAllProductCardSwipers();
  
  // Update swipers to match initial mode
  setTimeout(() => {
    updateAllSwipers();
  }, 100);

  // Add mode change listener
  const switchContainer = document.querySelector('.switch-view-container');
  if (switchContainer) {
    switchContainer.addEventListener('click', function (e) {
      const target = e.target.closest('[data-mode]');
      if (target) {
        const newMode = target.getAttribute('data-mode');
        document.body.setAttribute('data-card-mode', newMode);
        switchContainer.querySelectorAll('[data-mode]').forEach(el => el.classList.remove('active'));
        target.classList.add('active');
        updateAllSwipers(); // Update all Swipers when mode changes
      }
    });
  }

  // Listen for custom events from the facets update
  document.addEventListener('product-grid-updated', function () {
    initializeAllProductCardSwipers();
    // Update swipers after reinitializing
    setTimeout(() => {
      updateAllSwipers();
    }, 100);
  });
});